import axios from "axios";
import { type MsgToWorker } from "./type";

onmessage = (event) => {
    const data = event.data as MsgToWorker;
    if (data === "fetchFollowedProductIds") {
        fetchFollowedProductIds().then((result) => {
            postMessage(result);
        });
    }
};

async function fetchFollowedProductIds() {
    const response = await axios.post<number[]>(
        `/auctionProduct/GetSubscribedProducts`
    );
    return response.data;
}
